import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { BeneficiaryGender } from '@core/entities/models/beneficiary.model';
import { pastOrTodayDateValidator } from '@core/utils/validators/past-or-today-date.validator';

/**
 * Límites de caracteres por campo del beneficiario. Fuente única de verdad,
 * compartida por el diálogo de alta/edición y el registro público.
 */
export const BENEFICIARY_FIELD_LIMITS = {
  firstNameMax: 50,
  lastNameMax: 100,
  emailMin: 6,
  emailMax: 320,
  phoneMin: 6,
  phoneMax: 15,
  externalIdMax: 16,
} as const;

/** Opciones del desplegable de género (i18n). */
export const BENEFICIARY_GENDER_OPTIONS: { value: BeneficiaryGender; labelKey: string }[] = [
  { value: 'FEMALE', labelKey: 'beneficiaries.form.gender.options.FEMALE' },
  { value: 'MALE', labelKey: 'beneficiaries.form.gender.options.MALE' },
  { value: 'NON_BINARY', labelKey: 'beneficiaries.form.gender.options.NON_BINARY' },
  { value: 'PREFER_NOT_TO_SAY', labelKey: 'beneficiaries.form.gender.options.PREFER_NOT_TO_SAY' },
];

export type BeneficiaryFormMode = 'create' | 'edit';

/**
 * Crea el FormGroup del beneficiario con las validaciones canónicas.
 * En modo `create` el consentimiento GDPR es obligatorio; en `edit` no.
 */
export function createBeneficiaryForm(fb: FormBuilder, mode: BeneficiaryFormMode): FormGroup {
  const L = BENEFICIARY_FIELD_LIMITS;

  return fb.group({
    firstName: ['', [Validators.required, Validators.maxLength(L.firstNameMax)]],
    lastName: ['', [Validators.required, Validators.maxLength(L.lastNameMax)]],
    email: [
      '',
      [
        Validators.required,
        Validators.email,
        Validators.minLength(L.emailMin),
        Validators.maxLength(L.emailMax),
      ],
    ],
    phone: [
      '',
      [
        Validators.required,
        Validators.minLength(L.phoneMin),
        Validators.maxLength(L.phoneMax),
        Validators.pattern(/^[0-9+\.\s\-\(\)]+$/),
      ],
    ],
    birthDate: ['', [Validators.required, pastOrTodayDateValidator()]],
    gender: ['', [Validators.required]],
    birthCountry: ['', [Validators.required]],
    hostCountry: ['', [Validators.required]],
    externalId: ['', [Validators.maxLength(L.externalIdMax)]],
    gdprConsent: [false, mode === 'create' ? [Validators.requiredTrue] : []],
  });
}
